var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo",style:(("width: " + (_vm.squared ? _vm.height : _vm.width) + "; height: " + (_vm.squared ? _vm.height : _vm.height) + ";")),attrs:{"alt":(_vm.type + " logo"),"src":_vm.url},on:{"click":_vm.emitOnClick}})}
var staticRenderFns = []

export { render, staticRenderFns }